export default __webpack_public_path__ + "static/media/Plane.1fc57204.png";